import { resolveLocationTimezone } from '../../domain/locationTimezone.js';
import type { OperatingSchedule } from '../../domain/types.js';
import { isValidIanaTimezone } from './locationSpelling.js';

/** When strategy is location, store the resolved IANA id on schedule.timezone. */
export function scheduleWithLocationTimezone(
  schedule: OperatingSchedule,
  locationRegion: string | undefined,
): OperatingSchedule {
  if (schedule.timezoneStrategy !== 'location') return schedule;
  const trimmed = locationRegion?.trim();
  if (!trimmed) {
    return { ...schedule, timezone: undefined };
  }
  const mapTz = resolveLocationTimezone(trimmed);
  if (mapTz) {
    return { ...schedule, timezone: mapTz };
  }
  if (schedule.timezone && isValidIanaTimezone(schedule.timezone)) {
    return schedule;
  }
  return { ...schedule, timezone: undefined };
}
